import { subscribe } from '../js/ports.js';

/**
 *
 * @param app
 */
export function initialize(app) {
  subscribe(app, 'setHtmlLang', (language) => {
    document?.documentElement?.setAttribute('lang', language);
  });
}
